import { useQuery } from '@tanstack/react-query';

import missionQueries from '@carers/views/Missions/utils/missionQueryFactory';

const useGetMissionsByMonth = (date: string) => useQuery(missionQueries.byMonth(date));

export default useGetMissionsByMonth;
